export default __webpack_public_path__ + "static/media/off.88fcc885.png";